import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { Button, Col, Container, Row } from "reactstrap";
import BaseInput from "../../../../../toolkit/baseInput";
import ModalFrame from "../../../../../toolkit/modalFrame";
import { handleRequestError } from "../../../../../utils/helpers";
import { getAnnuitiesByMaintenanceAndClubRequest } from "../../../../actions/annuities";
import { Partner } from "../../interfaces";
import s from "../styles.scss";

interface Props {
  partner: Partner;
  annuitiesAvailableMaintenances: any[];
  idMembresiaSocio: string;
  cotizacionProductoItemId: string;
  igualaType: string;
  isOpen: boolean;
  isSaving: boolean;
  onCancel: () => any;
  onOk: (params: any) => any;
}

interface State {
  igualaAmount: any;
  igualaConcept: any;
  igualaNuevoMantenimiento: any;
  igualaNuevaAnualidad: any;
  annuities: any[];
}

class CreateIgualaChargeModal extends React.Component<Props, State> {
  state = {
    igualaAmount: null,
    igualaConcept: null,
    igualaNuevoMantenimiento: null,
    igualaNuevaAnualidad: null,
    annuities: []
  };

  componentDidMount() {}

  handleInputIgualaChange = e => {
    this.setState({ igualaAmount: e.target.value });
  };

  handleInputConceptoChange = e => {
    this.setState({ igualaConcept: e.target.value });
  };

  handleInputNuevoMantenimientoChange = e => {
    const mantenimientoId = e.target.value;
    this.setState({
      igualaNuevoMantenimiento: mantenimientoId,
      igualaNuevaAnualidad: null
    });

    //Se consultan las anualidades disponibles
    this.loadAnnuities(
      mantenimientoId,
      this.props.partner.idClubBase,
      this.props.partner.idMembresiaSocio
    );
  };

  handleInputNuevaAnualidadChange = e => {
    const anualidadId = e.target.value;
    this.setState({ igualaNuevaAnualidad: anualidadId });
  };

  loadAnnuities = (maintenanceId: any, clubId: any, membresiaSocioId: any) => {
    if (!maintenanceId || !clubId) {
      return;
    }

    getAnnuitiesByMaintenanceAndClubRequest(
      maintenanceId,
      clubId,
      membresiaSocioId
    )
      .then(({ data }) => {
        this.setState({ annuities: [...data] });
      })
      .catch(handleRequestError);
  };

  render() {
    const {
      igualaType,
      isOpen,
      isSaving,
      cotizacionProductoItemId,
      onOk,
      onCancel
    } = this.props;
    const {
      igualaAmount,
      igualaConcept,
      igualaNuevoMantenimiento,
      igualaNuevaAnualidad
    } = this.state;

    return (
      <ModalFrame
        title={
          (igualaType || "MANTENIMIENTO") == "MANTENIMIENTO"
            ? "Generar cargo de iguala de plan"
            : "Generar cargo de iguala de anualidad"
        }
        isOpen={isOpen}
        toggle={() => {
          if (!!onCancel) {
            onCancel();
          }
        }}
      >
        <Container>
          <p>
            {(igualaType || "MANTENIMIENTO") == "MANTENIMIENTO"
              ? "Se generará un cargo de iguala de plan con el monto ingresado. ¿Desea continuar?"
              : "Se generará un cargo de iguala de anualidad con el monto ingresado y con las condiciones seleccionadas. ¿Desea continuar?"}
          </p>

          <Row>
            <p className={`w-100`}>
              <BaseInput
                label={"Importe"}
                name="cantidadImporte"
                type="number"
                id="cantidadImporte"
                placeholder="Importe"
                onChange={this.handleInputIgualaChange}
              />
            </p>
          </Row>

          {(igualaType || "MANTENIMIENTO") == "ANUALIDAD" && (
            <Row>
              <p className={`w-100`}>
                <BaseInput
                  label={"Concepto"}
                  name="conceptoIguala"
                  type="text"
                  id="conceptoIguala"
                  placeholder="Concepto"
                  onChange={this.handleInputConceptoChange}
                />
              </p>
              <p className={`w-100`}>
                <BaseInput
                  type="select"
                  id="cargoIgualaNuevoMantenimiento"
                  name="cargoIgualaNuevoMantenimiento"
                  label="Asignar nuevo mantenimiento"
                  onChange={this.handleInputNuevoMantenimientoChange}
                  options={[{ value: "", label: "Seleccionar plan" }].concat(
                    (this.props.annuitiesAvailableMaintenances || []).map(
                      option => ({
                        value: option.datosBasicosMantenimientoId,
                        label: option.nombre
                      })
                    )
                  )}
                />
              </p>
              <p className={`w-100`}>
                <BaseInput
                  type="select"
                  id="cargoIgualaNuevoMantenimiento"
                  name="cargoIgualaNuevoMantenimiento"
                  label="Asignar nuevo tipo de anualidad"
                  onChange={this.handleInputNuevaAnualidadChange}
                  options={[
                    { value: "", label: "Seleccionar anualidad" }
                  ].concat(
                    (this.state.annuities || []).map(option => ({
                      value: option.id,
                      label: `${option.nombre} (${option.tipo})`
                    }))
                  )}
                />
              </p>
            </Row>
          )}

          <Row className="mt-4">
            <Col className="text-right">
              <Button
                color="primary"
                onClick={() => {
                  if (!!onOk) {
                    onOk({
                      cotizacionProductoItemId,
                      tipo: igualaType,
                      monto: igualaAmount,
                      concepto: igualaConcept,
                      nuevoMantenimientoId: igualaNuevoMantenimiento,
                      nuevaAnualidadId: igualaNuevaAnualidad
                    });
                  }
                }}
                style={{ marginRight: "15px" }}
                disabled={
                  !igualaAmount || parseFloat(igualaAmount) <= 0 || !!isSaving
                }
              >
                Generar
              </Button>

              <Button
                color="secondary"
                onClick={() => {
                  if (!!onCancel) {
                    onCancel();
                  }
                }}
              >
                Cancelar
              </Button>
            </Col>
          </Row>
        </Container>
      </ModalFrame>
    );
  }
}

export default withStyles(s)(CreateIgualaChargeModal);
